export default __webpack_public_path__ + "static/media/mst.e1f85e03.png";